<template>
  <div>
    <v-list-item
      v-if="listItem"
      class="login-logo-container pl-4 d-flex align-center"
    >
      <v-list-item-content>
        <v-list-item-title
          class="font-weight-black login-logo-text-caption text-uppercase"
        >
          <div
            class="login-title-light"
            :class="{ 'login-title-inverted': dark }"
          >
            {{ alt ? "Admin" : "C M S" }}
          </div>
          <div
            class="login-title-dark login-subtitle"
            :class="{ 'login-title-inverted': dark }"
          >
            {{ title }}
          </div>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <div v-else class="d-flex align-center justify-center">
      <div
        class="font-weight-black login-logo-text-caption text-uppercase"
        :class="alt ? 'd-flex align-center' : ''"
      >
        <div
          class="login-title-light"
          :class="{ 'login-title-inverted': dark }"
        >
          {{ alt ? "Admin" : "C M S" }}
        </div>
        <div v-if="alt" class="mx-3 pb-1">::</div>
        <div
          class="login-title-dark login-subtitle"
          :class="{ 'login-title-inverted': dark }"
        >
          {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoLight from "./../../../public/img/logo-light.svg";
import LogoDark from "./../../../public/img/logo-dark.svg";
import "./ProductTitle.scss";

export default {
  name: "ProductTitle",

  props: {
    title: {
      type: String,
      required: true
    },
    titleLightLength: {
      type: Number,
      default: 0
    },
    dark: {
      type: Boolean,
      default: false
    },
    listItem: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    alt() {
      return process.env.VUE_APP_ALT || false;
    },
    logo() {
      return this.dark ? LogoDark : LogoLight;
    },

    // разбиваем заголовок на светлую и брендовую части
    titleParts() {
      const { title, titleLightLength } = this;
      let partLight, partBrand;
      if (titleLightLength) {
        // разбиваем по явно указанной длине
        partBrand = title.substr(titleLightLength);
        partLight = title.substr(0, titleLightLength);
      } else {
        // пытаемся разбить по поиску точки
        [partLight, partBrand = ""] = title.split(".");
        if (partBrand.length) {
          // название с точкой, добавляем точку к светлой части
          partLight += ".";
        } else {
          // название без точки, бьём на глазок
          const partLength = Math.floor(title.length / 2);
          partBrand = partLight.substr(partLength);
          partLight = partLight.substr(0, partLength);
        }
      }
      return [partLight, partBrand];
    }
  }
};
</script>
